import {
  SiJeep,
  SiToyota,
  SiHonda,
  SiFord,
  SiTesla,
  SiVolkswagen,
  SiNissan,
  SiChevrolet,
  SiSkoda,
  SiBmw,
  SiKia,
  SiHyundai,
} from 'react-icons/si';

const size = 50;

export const carIcons = [
  {
    id: 1,
    title: 'Jeep',
    img: <SiJeep size={size} />,
  },
  {
    id: 2,
    title: 'Toyota',
    img: <SiToyota size={size} />,
  },
  {
    id: 3,
    title: 'Honda',
    img: <SiHonda size={size} />,
  },
  {
    id: 4,
    title: 'Ford',
    img: <SiFord size={size} />,
  },
  {
    id: 5,
    title: 'Tesla',
    img: <SiTesla size={size} />,
  },
  {
    id: 6,
    title: 'Volkswagen',
    img: <SiVolkswagen size={size} />,
  },
  {
    id: 7,
    title: 'Nissan',
    img: <SiNissan size={size} />,
  },
  {
    id: 8,
    title: 'Chevrolet',
    img: <SiChevrolet size={size} />,
  },
  {
    id: 9,
    title: 'BMW',
    img: <SiBmw size={size} />,
  },
  {
    id: 10,
    title: 'Hyundai',
    img: <SiHyundai size={size} />,
  },
  {
    id: 11,
    title: 'KIA',
    img: <SiKia size={size} />,
  },
  {
    id: 12,
    title: 'Skoda',
    img: <SiSkoda size={size} />,
  },
];
